import {CreateSavedView, IObject, SavedViewGroup, SavedViewId} from "platformed-client/types";
import {invalidateQueries, q} from "../state";
import {platformedClient} from ".";

export async function list(view_key: string) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/saved_views/{view_key}", {
    path: {view_key},
  });
}

export async function create(view_key: string, create: CreateSavedView) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/saved_views/{view_key}", {
    path: {view_key},
    body: create,
  });
  await invalidateQueries([q.savedViews.filter()]);
  return res;
}

export async function updateName(view_key: string, savedViewId: SavedViewId, name: string) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/saved_views/{view_key}/{view_id}/name",
    {path: {view_key, view_id: savedViewId}, body: name},
  );
  await invalidateQueries([q.savedViews.filter()]);
  return res;
}

export async function updateGroup(view_key: string, savedViewId: SavedViewId, group: SavedViewGroup) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/saved_views/{view_key}/{view_id}/group",
    {path: {view_key, view_id: savedViewId}, body: group},
  );
  await invalidateQueries([q.savedViews.filter()]);
  return res;
}

export async function makeDefault(view_key: string, savedViewId: SavedViewId) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/saved_views/{view_key}/{view_id}/make_default",
    {path: {view_key, view_id: savedViewId}},
  );
  await invalidateQueries([q.savedViews.filter()]);
  return res;
}

export async function updatePayload(view_key: string, savedViewId: SavedViewId, payload: IObject) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/saved_views/{view_key}/{view_id}/payload",
    {path: {view_key, view_id: savedViewId}, body: payload},
  );
  await invalidateQueries([q.savedViews.filter()]);
  return res;
}

export async function delete_(view_key: string, savedViewId: SavedViewId) {
  const res = await platformedClient.internalRequest(
    "delete",
    "/region/{region}/api/saved_views/{view_key}/{view_id}",
    {path: {view_key, view_id: savedViewId}},
  );
  await invalidateQueries([q.savedViews.filter()]);
  return res;
}
